import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
   
      <div className="footer-columns">
        <div className="footer-column">
          <h3>Products</h3>
          <ul>
            <li>Self checkout system</li>
            <li>Intelligent transport system</li>
            <li>Retail monitoring system </li>
            <li>Facial Recognition system </li>
            <li></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Services</h3>
          <ul>
            <li>AI Training</li>
            <li>Custom Models</li>
            <li>AI Data Analysis </li>
            <li>Custom GPTS</li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Deployments</h3>
          <ul>
            <li></li>
            <li>Banking Solutions</li>
            <li>Edge Computing Systems</li>
            <li>Custom GPTS</li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Global</h3>
          <div className="footer-contact-info">
            <p>Email: <a href="mailto:info@atastra.org">info@atastra.org</a></p>
            <p>Phone: +254757066479</p>
            <h4>Invest in our vision</h4>
         
          </div>
        </div>

       
      </div>

      <div className="footer-bottom">
        &copy; 2025 Atastra, all rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
